export default {
	intEmpresaAtivo:null,
}